import usePopoverConfirm from '@/hooks/ui/use-popover-confirm.hook'
import useSnackbar from '@/hooks/ui/use-snackbar.hook'
import { PopoverConfirmComponent } from '@/views/components'

import SnackbarWrapper from '@/views/components/snackbar/snackbar.component'

export const UiBonusesFeedbackComponent = () => {
  const { snackbar, closeHandler } = useSnackbar({})
  const { popoverConfirm, handleClosePopoverConfirm } = usePopoverConfirm()

  return (
    <>
      <PopoverConfirmComponent
        {...popoverConfirm}
        handleClosePopoverConfirm={handleClosePopoverConfirm}
      />
      <SnackbarWrapper
        message={snackbar.message}
        open={snackbar.open}
        handleClose={closeHandler}
        variant={snackbar.variant}
        automaticClose
      />
    </>
  )
}
